module.exports = __webpack_public_path__ + "img/code5.89968651.png";